import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../Components/Button";
import ErrorMessage from "../Components/ErrorMessage";
import InputBoxDisableTrans from "../Components/InputBoxDisableTrans";
import Footer from "../Layout/Footer";
import "../Styles/global.css";

const PASSWORD_RESET_EMAIL_KEY = "passwordResetEmail";

const EmailAuth = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error_message, setError_message] = useState("");

  const handleInput = (value) => {
    setEmail(value);
  };

  const emailAuthentication = async () => {
    // 인증메일 발송 성공 => state: {emailsent:true}
    // 인증메일 발송 실패 => state: {emailsent:false}
    if (email) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/dashboard/auth/sendEmail`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email,
            }),
          }
        );
        const data = await response.json();

        if (data.code === 200) {
          localStorage.setItem("sentTime", Math.floor(Date.now() / 1000));
          localStorage.setItem(PASSWORD_RESET_EMAIL_KEY, email);
          navigate("/emailauth/sent", {
            state: {
              toast_enable: true,
              toast_message: "인증 메일이 발송되었습니다.",
              toast_type: "success",
              email_address: email,
              cert_num: data.data.certifyNumber,
            },
          });
        } else if (data.code === 1002) {
          console.log("파트너스 정보 없음");
        } else if (data.code === 1005) {
          navigate("/emailauth/sent", {
            state: {
              toast_enable: true,
              toast_message:
                "메일 발송 가능 건수를 초과하였습니다. 5분 뒤에 다시 시도해주세요.",
              toast_type: "error",
            },
          });
        } else if (data.code === 1006) {
          navigate("/emailauth/sent", {
            state: {
              toast_enable: true,
              toast_message:
                "인증 메일 발송에 실패하였습니다. 다시 한 번 시도해주세요.",
              toast_type: "error",
            },
          });
        }
      } catch (error) {
        console.error("인증메일 발송 중 에러: ", error);
        throw error;
      }
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="page-wrapper center">
      <div>
        <AuthBox>
          <h1>이메일 인증</h1>
          <p style={{ marginTop: 10 }}>
            비밀번호 재설정을 위해 이메일을 인증해주세요.
          </p>
          <div style={{ marginTop: 30 }}>
            <InputBoxDisableTrans
              message="기업 이메일 입력"
              handleInput={handleInput}
              setError_message={(value) => setError_message(value)}
              type="email"
            />
          </div>
          {error_message && <ErrorMessage message={error_message} />}
          <div onClick={emailAuthentication} style={{ marginTop: 40 }}>
            <Button message="인증 메일 받기" />
          </div>
        </AuthBox>
      </div>
      <Footer />
    </div>
  );
};

const AuthBox = styled.div`
  width: 400px;
  height: auto;
  margin-top: 240px;
  margin-bottom: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "notoSans";
  > h1 {
    margin: 0;
    font-size: 30px;
    font-weight: bold;
  }
  > p {
    font-size: 16px;
    color: #888888;
    margin: 0;
  }
`;

export default EmailAuth;
